import { render } from "./ProjectAccessModal.vue?vue&type=template&id=bb8cb656&scoped=true"
import script from "./ProjectAccessModal.vue?vue&type=script&lang=js"
export * from "./ProjectAccessModal.vue?vue&type=script&lang=js"

import "./ProjectAccessModal.vue?vue&type=style&index=0&id=bb8cb656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8cb656"]])

export default __exports__